import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';


const App = () => {
  return (
    <div id="firegram">
      <Header/>
      <div className="container">
        <Switch>
            <Route exact path="/">
              <Home/>
            </Route>           
        </Switch>
      </div>
      <Footer/>
    </div>
  )
}

export default App;
